import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3c0e380"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-x2" }, "Theo dõi thực hiện hợp đồng", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " theo dõi thực hiện hợp đồng ", -1))
const _hoisted_3 = {
  class: "text-center mb-2 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_4 = {
  class: "text-center mb-3 fst-italic",
  style: {"font-size":"0.9rem"}
}
const _hoisted_5 = {
  key: 0,
  class: "text-center mb-2 fst-italic",
  style: {"font-size":"0.9rem"}
}
const _hoisted_6 = {
  key: 1,
  class: "text-center mb-0 fst-italic",
  style: {"font-size":"0.9rem"}
}
const _hoisted_7 = { class: "me-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, " ĐVT: đồng ", -1))
const _hoisted_9 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_10 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import {
  computed,
  PropType,
  ref,
} from "vue";
import { printHtmlElement } from "@/core/helpers/html-to-paper";
import { ButtonsType } from "@/core/enums/buttons.enums";
import {
  IHopDongResponseBase,
  IKhoResponseBase,
  ITheoDoiThucHienHopDongResponseBase,
} from "@/core/interfaces/ApiResponses";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import SignatureCol from "@/layout/_shared/SignatureCol.vue";
import TheoDoiHopDongTable from "../table-components/TheoDoiHopDongTable.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";

const modalId = "modal-id-print-modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiHopDongPrintModal',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  hopDong: {
    type: Object as PropType<IHopDongResponseBase | null>,
    default: null,
  },
  items: {
    type: Array as PropType<ITheoDoiThucHienHopDongResponseBase[]>,
    default: () => [],
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: {
    type: Date,
    default: new Date(),
  },
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const emit = __emit;

const isOpen = ref(false);

const onPrintingButtonClicked = () => {
  printHtmlElement(modalId);
};

const dateDisplay = computed(
  () => `Đến tháng ${props.to.getMonth() + 1} năm ${props.to.getFullYear()}`
);

__expose({ isOpen });

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    width: "90%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(DivRow, { class: "mb-2" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 10 }),
            _createVNode(DivCol, {
              cols: 2,
              class: "text-end justify-content-end"
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).PRINT,
                  onClick: onPrintingButtonClicked
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("In phiếu")
                  ]),
                  _: 1
                }, 8, ["button-type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          id: modalId,
          class: "printing-paper"
        }, [
          _createVNode(PdfDocumentHeader, {
            "ten-don-vi": resolvedTenDonVi.value,
            "ten-don-vi-cha": resolvedTenDonViCha.value
          }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
          _createVNode(DivRow, { class: "mb-3" }, {
            default: _withCtx(() => [
              _createVNode(DivCol),
              _createVNode(DivCol, {
                cols: 10,
                "additional-class": "flex-column"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("p", _hoisted_3, _toDisplayString(dateDisplay.value), 1),
                  _createElementVNode("p", _hoisted_4, " Nhập tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1),
                  (__props.hopDong)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Hợp đồng cung cấp vật tư hàng hoá số: " + _toDisplayString(__props.hopDong?.so_hop_dong) + " Ngày " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getDate()) + " Tháng " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getMonth() + 1) + " năm " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getFullYear()), 1))
                    : _createCommentVNode("", true),
                  (__props.hopDong)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, "Tên đơn vị cấp vật tư, hàng hoá: " + _toDisplayString(__props.hopDong.ten_doi_tac), 1),
                        _createElementVNode("span", null, "Tài khoản: " + _toDisplayString(__props.hopDong.ma_tk) + " / " + _toDisplayString(__props.hopDong.ma_ct), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(DivCol)
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(DivRow, null, {
            default: _withCtx(() => [
              _createVNode(DivCol, { cols: 12 }, {
                default: _withCtx(() => [
                  _createVNode(TheoDoiHopDongTable, {
                    "is-print-modal": true,
                    items: __props.items,
                    stripe: false
                  }, null, 8, ["items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
            ]),
            _createElementVNode("div", null, [
              _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
            ])
          ])
        ])
      ])), [
        [_directive_dialog_auto_focus, isOpen.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})